import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const useLoader = () => {
  const loading = [useSelector((state: RootState) => state.currentUser.fullScreenLoader)].includes(true);
  return loading;
};

export default useLoader;
